import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PrinterType } from 'src/app/core/models/printer-type.model';
import { User } from 'src/app/core/models/user.model';
import { UserType } from 'src/app/core/models/userType.models';
import { PrinterTypeService } from 'src/app/core/services/printer-type.service';
import { UserService } from 'src/app/core/services/user.service';

@Component({
  selector: 'app-board',
  templateUrl: './printerType.component.html',
  styleUrls: ['./printerType.component.scss']
})

/**
 * Dashboard Component
 */
export class PrinterTypeComponent implements OnInit {
  term: any;
  printerType: any[];

  addEditMode: any;
  printTypeFormGroup: FormGroup;


  constructor(
    private printerTypeService: PrinterTypeService, 
    private modalService: NgbModal,
    private router: Router
  ) { }

  // bread crumb items
  breadCrumbItems: Array<{}>;

  async ngOnInit(): Promise<void> {
    this.breadCrumbItems = [{ label: 'Fortune' }, { label: 'Printer Type', active: true }];
    await this.refresh();
  }

  async refresh() {
    
    this.printerType = await this.printerTypeService.getAll();
  

    console.log("refresh called", this)
  }

  async onAddNew(modal: unknown) {
    this.addEditMode = "Add";
    this.printTypeFormGroup = new FormGroup({
      id: new FormControl<string>(''),
      name: new FormControl<string>(''),


    });
    try {
      const results = await this.modalService.open(modal).result;
      console.log('add edit modal returned', {results, saleRepAddEditFormGroup: this.printTypeFormGroup.value});
      if(results=="Save click") {
        const newPrinterType = await this.printerTypeService.create(this.printTypeFormGroup.value);
        if(newPrinterType != null) {
          //TODO mark sucesss
        } else {
          //TODO mark failure
        }
      } else {
        //TODO mark cancel
      }
    } catch (error) {
      //TODO mark error
    }
    await this.refresh();
  }

  async onEdit(modal: unknown, original: PrinterType) {
    this.addEditMode = "Edit";
    this.printTypeFormGroup = new FormGroup({
      id: new FormControl<string>(original.id),
      name: new FormControl<string>(original.name),
      

    });
    try {
      const results = await this.modalService.open(modal).result;
      console.log('add edit modal returned', {results, gameFormGroup: this.printTypeFormGroup.value});
      if(results=="Save click") {
        const newGame = await this.printerTypeService.update(original.id, this.printTypeFormGroup.value);
        if(newGame != null) {
          //TODO mark sucesss
        } else {
          //TODO mark failure
        }
      } else {
        //TODO mark cancel
      }
    } catch (error) {
      //TODO mark error
    }
    await this.refresh();
    
  } 

  async onDelete( id: string) {
    await this.printerTypeService.delete(id);
    await this.refresh();     
  } 
}
